import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a4e62f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "common-layout"
}

import { ElLoading } from 'element-plus';
import { onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import SideBar from '@/components/SideBar/index.vue';
import TopBar from '@/components/TopBar/index.vue';
import { getUserProjectResources } from '@/api/common';
import { useUserStore } from '@/store';
import { getSystemId } from '@/utils/index';
import { useAuthorityStore } from './store/modules/useAuthorityStore';
import DownloadPopover from '@/components/downloadPopover/index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const name = ref<string>('权限中心');
const icon = ref<string>();
const authorityStore = useAuthorityStore();
onMounted(async () => {
  const currentSid = getSystemId() || 0;
  authorityStore.updateSystemId(currentSid);
  await authorityStore.tryLoadUserSystems();
  authorityStore.systems.forEach((value) => {
    if (value.sid === currentSid) {
      name.value = value.sysName;
      icon.value = value.sysIcon;
    }
  });

  console.log('authorityStore.systems', authorityStore.systems);
});

const userStore = useUserStore();
// const sysStore = useSystemStore();
// 是否展示内容
const isShowContent = ref(false);

const loading = ElLoading.service({
  lock: true,
  text: 'Loading',
  background: 'rgba(0, 0, 0, 0.7)'
});

// projects 为主应用左侧展示的菜单栏
const menuList = ref<any>([]);

watch(
  () => userStore.menuList,
  () => {
    console.log(userStore.menuList);
    menuList.value = userStore.menuList;
  }
);
const getMenu = async () => {
  console.log('我去获取菜单');
  // 根据系统id获取当前用户可查看的项目。 然后生成左侧菜单，并存入store
  // 因为权限系统就存在一个权限项目，所以直接将权限项目的一级菜单作为左侧菜单
  // 在路由跳转的时候，查看当前store内是否有菜单数据，以及菜单是否有当前的路由。 没有就跳转到404页面。
  // 整个页面添加loading， 当数据请求回来之后，
  try {
    // const userProjects = await getUserProjects(getSystemId());
    // 权限系统只有一个权限项目，所以直接取第0项。
    // const powerProjectInfo = userProjects.data.projects[0];
    // 不存在，那么说明他没有任何权限，直接跳转到申请权限页面
    // if (!powerProjectInfo) {
    //   router.push({ path: '/myAuth/apply' });
    //   isShowContent.value = true;
    //   loading.close();
    //   return;
    // }
    // 请求权限项目对应的权限树
    const powerProjectResources = await getUserProjectResources(
      process.env.VUE_APP_PROJECT_ID ? parseInt(process.env.VUE_APP_PROJECT_ID, 10) : 37
    );
    console.log(powerProjectResources, 'powerProjectResources.data.resources');
    // 权限树的结构是 一级菜单 / 二级菜单 / 独立页面 / 按钮(接口) 或者是 一级菜单 / 独立页面 / 按钮(接口)
    // 根据 resourceType 判断 一级菜单: 1, 二级菜单: 2, 独立页面: 3, 按钮: 4
    // 直接将整棵树存入store内部
    userStore.updateAuth(powerProjectResources.data.resources);

    // 当用户只有 我的权限的权限 而且我的权限中只有 申请申请权限的权限，则自动跳转到申请权限页面
    // 当用户没有任何权限，自动跳转到申请权限页面

    const onlyHasMyAuth =
      powerProjectResources.data.resources.length === 1 &&
      powerProjectResources.data.resources[0].url === '/myAuth' &&
      powerProjectResources.data.resources[0].children?.length === 1 &&
      powerProjectResources.data.resources[0].children[0].url === '/myAuth/apply';

    // 没有任何权限
    const hasNoAuth = powerProjectResources.data.resources.length === 0;
    console.log(onlyHasMyAuth, hasNoAuth);
    if (onlyHasMyAuth || hasNoAuth) {
      router.push({ path: '/myAuth/apply' });
      isShowContent.value = true;
      loading.close();
      return;
    }
  } catch (e) {
    loading.close();
    console.log('error', e);
  }

  isShowContent.value = true;
  loading.close();
};
getMenu();

return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (isShowContent.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_container, { class: "main-wrap" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, {
              width: "138px",
              class: "el-aside"
            }, {
              default: _withCtx(() => [
                _createVNode(SideBar, { menus: menuList.value }, null, 8, ["menus"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_header, { class: "el-header" }, {
                  default: _withCtx(() => [
                    _createVNode(TopBar, {
                      name: name.value,
                      icon: icon.value!
                    }, null, 8, ["name", "icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_main, { class: "el-main" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(DownloadPopover)
      ]))
    : _createCommentVNode("", true)
}
}

})